import { useNavigate, useParams } from 'react-router-dom'

import { CompetencyRoleLevelsPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useCompetenciesFeatures } from 'modules/competencies/hooks/useCompetenciesFeatures'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import CompetencyRoleLevelsDataCollection from './CompetencyRoleLevelsDataCollection'

const CompetencyRoleLevelsPage = () => {
  const { competencyId } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  if (!competencyId) {
    throw new Error('Competency ID is required')
  }

  const { data, loading, error } = useQuery(CompetencyRoleLevelsPageDocument, {
    variables: {
      competencyId: Number(competencyId),
    },
  })

  const competency = data?.competencies?.competency
  const canManageJobCatalogTree = data?.jobCatalog._policies.jobCatalogTreeManage.can ?? false

  const { isJobCatalogTreeEnabled } = useCompetenciesFeatures()

  if (!isJobCatalogTreeEnabled) {
    navigate(navigation.competencies.competencyId.fullPath({ competencyId }))
  }

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {competency && (
        <CompetencyRoleLevelsDataCollection
          competency={competency}
          canManageJobCatalogTree={canManageJobCatalogTree}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default CompetencyRoleLevelsPage
